import { GlPopover, GlLoadingIcon, GlLink } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { n__ } from '~/locale';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { titleInLinkSafeHtmlConfig } from '~/lib/dompurify';
import { WORK_ITEM_TYPE_NAME_ISSUE, STATE_CLOSED } from '~/work_items/constants';
import WorkItemRelationshipPopoverMetadata from '../../../../../../ee/app/assets/javascripts/work_items/components/shared/work_item_relationship_popover_metadata.vue?vue3';
import WorkItemTypeIcon from '../work_item_type_icon.vue?vue3';
const defaultDisplayLimit = 3;
export default {
    name: 'WorkItemRelationshipPopover',
    components: {
        GlPopover,
        GlLoadingIcon,
        GlLink,
        WorkItemTypeIcon,
        WorkItemRelationshipPopoverMetadata
    },
    directives: {
        SafeHtml
    },
    titleInLinkSafeHtmlConfig,
    props: {
        linkedWorkItems: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        title: {
            type: String,
            required: true
        },
        target: {
            type: String,
            required: true
        },
        workItemFullPath: {
            type: String,
            required: true
        },
        workItemType: {
            type: String,
            required: true
        },
        workItemWebUrl: {
            type: String,
            required: true
        },
        loading: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    emits: [
        'click',
        'mouseout',
        'mouseover'
    ],
    defaultDisplayLimit: 3,
    computed: {
        atLinkedItemsDisplayLimit () {
            return this.linkedWorkItems.length > defaultDisplayLimit;
        },
        displayedIssuablesCount () {
            return this.atLinkedItemsDisplayLimit ? this.linkedWorkItems.length - defaultDisplayLimit : this.linkedWorkItems.length;
        },
        moreItemsText () {
            return n__('WorkItem|+%d more item', 'WorkItem|+%d more items', this.displayedIssuablesCount);
        },
        linkedItemsToDisplay () {
            // Filtering closed child linked items and cutting to deafult display amount
            return this.linkedWorkItems.filter((item)=>{
                return item.workItemState !== STATE_CLOSED;
            }).slice(0, defaultDisplayLimit);
        },
        moreItemsLink () {
            return `${this.workItemWebUrl}#${this.workItemType === WORK_ITEM_TYPE_NAME_ISSUE ? 'related-issues' : 'linkeditems'}`;
        }
    }
};
